import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import LegacyPicture from '../LegacyPicture/LegacyPicture';
import { CLASSIC_BREAKPOINT_ASPECT_RATIO_CONFIGS } from '../LegacyPicture/consts';
import LinkButton from '../LinkButton/LinkButton';
import RichText from '../RichText/RichText';
import styles from './RegioTeaser.module.scss';
import type { RegioTeaserProps } from './interfaces';

const RegioTeaser = ({
  headline,
  description,
  link,
  linkExtern,
  linkText,
  image,
}: RegioTeaserProps) => {
  const isMobile = useIsMobile(992);

  return (
    <div className={styles.base}>
      <div className={styles.imageWrapper}>
        <LegacyPicture
          asset={image}
          fitCover
          breakpointAspectRatioConfigs={CLASSIC_BREAKPOINT_ASPECT_RATIO_CONFIGS}
        />
      </div>
      <div className={styles.content}>
        <h3 className={styles.headline}>{headline}</h3>
        <RichText className={styles.description}>{description}</RichText>
        <LinkButton
          iconPosition="left"
          variant="default"
          size={isMobile ? 'small' : 'large'}
          as="a"
          linkExtern={linkExtern}
          href={link}
          icon="action/arrow-right"
          disabled={false}
          align="left"
        >
          {linkText}
        </LinkButton>
      </div>
    </div>
  );
};

export default RegioTeaser;
